<template>
  <div class="contentBox">
    <navBox :id="navId" :cid="childrenID" ref="navBox"></navBox>
    <!-- 列表 -->
    <div class="content"  v-loading="loading" :element-loading-text="loadTxt">
      <myHeader ref="myHeader"></myHeader>
      <div class="MobelBox" v-if="addType">
        <p class="add-title">添加诊断</p>
        <div class="model-cont">
          <button class="btn btn-hide"  @click="closeSub">关闭</button>
          <div class="step-list">
            <div class="step-item" :class="next_id==item.id?'select':''" v-for="(item,index) in steptTitle" :key="item.id" @click="stepSub(item)">
              <p>{{(index+1)}}</p>
              <span>{{item.title}}</span>
              <i class="line" v-if="index<3"></i>
            </div>
          </div>
          
        </div>
        

        <div class="step-cont" v-if="next_id==1">
          <div v-if="addType=='add'">
            <div class="model-item">
              <p class="info-title">基本信息</p>
              <div class="write-txt">
                <p class="write-title"><span>*</span>选择学员：</p>
                <button class="btn btn-ai" @click="chooseStudent">{{addObj.uid?'已选择':'点击选择'}}</button>
                <div class="write-text">
                  
                </div>
              </div>
              <div class="write-txt">
                <p class="write-title"><span>*</span>选择试卷：</p>
                <div class="write-text">
                  <el-select placeholder="请选择" v-model="addObj.eid" @change="paperChange">
                    <el-option
                      v-for="item in examList"
                      :key="item.id"
                      :label="item.title"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </div>
              </div>
              <div class="write-txt">
                <p class="write-title"><span>*</span>考试时间：</p>
                <div class="write-text">
                  <el-date-picker
                    v-model="addObj.exam_time"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :picker-options="pickerOptions"
                    placeholder="选择日期">
                  </el-date-picker>
                  <!-- <p class="write-msg">仅能设置明天及以后的时间</p> -->
                </div>
              </div>
              <div class="write-txt write-ai">
                <p class="write-title">考试成绩：</p>
                <div class="write-text">
                  <input type="number" v-model="addObj.score">
                </div>
              </div>
              <div class="write-txt write-ai">
                <p class="write-title"><span>*</span>上传学员答题卷照片：</p>
                <div class="write-text">
                  <div class="img" @mouseenter="imgShow" @mouseleave="imgHide" v-show="imgObj.imgs.length>0" v-for="(item,index) in imgObj.imgs" :key="index">
                    <img :src="'https://pic.bi-rong.com/'+item" alt="">
                    <div class="hover" v-if="imgType">
                      <i class="el-icon-delete" @click="imgRemove(index)"></i>
                    </div>
                  </div>
                  <el-upload
                    :action="'https://upload.qiniup.com'"
                    :data="uploadObj"
                    list-type="picture-card"
                    :before-upload="beforeUploadImg"
                    :on-success="handleSuccessImg"
                    :on-progress="handleProgressImg"
                    :on-remove="handleRemoveImg"
                  >
                    <i class="el-icon-plus"></i>
                  </el-upload>
                  <el-dialog :visible.sync="dialogVisible">
                    <img
                      width="100%"
                      :src="'https://pic.speechcoach.cn/' + addObj.image"
                      alt=""
                    />
                  </el-dialog>
                  <button class="btn btn-img-add" @click="answerSub">确定</button>
                </div>
              </div>
            </div>
            <div class="model-cont" v-if="addObj.user_topic.length>0">
              <div class="model-item">
                <div class="write-txt">
                  <p class="write-title"><span>*</span>试卷内容</p>
                  <span class="ai-msg">以下为AI识别后的内容，可手动修改</span>
                  <div class="msg-txt">
                    <i class="icon icon-msg"></i>
                    AI识别可能导致内容丢失或错误，请进行人工校验!
                  </div>
                </div>

                <div class="write-txt" v-for="(item,index) in addObj.user_topic" :key="index">
                  <p class="add-title">板块{{(index+1)}}: {{item.title}}</p>
                  <div v-for="(ele,num) in item.topic" :key="num">
                    <div class="topic-data topic-data1">
                      <p class="write-title"><span>*</span>题干:</p>
                      <div class="write-text">
                          <textarea placeholder="请输入文章题干" v-model="ele.topic_title" disabled></textarea>
                      </div>
                    </div>
                    <div class="topic-data topic-data2">
                      <p class="write-title"><span>*</span>学员答案：</p>
                      <div class="write-text">
                          <textarea placeholder="请输入学员答案" v-model="ele.my_answer" disabled></textarea>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="wrongList">
                  <div class="wrong-item" v-for="(item,index) in errorObj.error_topic" :key="index">
                    <div class="write-txt write-ai">
                      <p class="write-title">错题题号：</p>
                      <div class="write-text">
                        <el-select placeholder="请选择" v-model="item.que_num">
                          <el-option
                            v-for="item in maximum"
                            :key="item"
                            :label="item"
                            :value="item">
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                    <div class="write-txt write-ai">
                      <p class="write-title">错题扣分：</p>
                      <div class="write-text">
                        <input type="text" v-model="item.deduct">
                      </div>
                      <button class="btn btn-topic-remove" @click="errorRemove(index)" v-if="index>0">删除</button>
                    </div>
                  </div>
                  <button class="btn btn-topic-add" @click="addError">+添加做错的题号</button>
                  <button class="btn btn-error" @click="ErrorAnalysis">生成分析统计</button>
                </div>
              </div>
              <div class="model-item clear" v-if="addObj.exam_sites.length>0">
                <p class="info-title">各个考点扣分情况</p>
                <div class="table-cont">
                  <div class="table-title">
                    <p v-for="(item,index) in tableTitle" :key="index">{{item.title}}</p>
                  </div>
                  <div class="table-list">
                    <div class="table-item" v-for="(item,index) in addObj.exam_sites" :key="index">
                      <p>{{item.exam_site}}</p>
                      <p>{{item.topic_score}}</p>
                      <p>{{item.deduct}}</p>
                      <p>{{item.deduct_rate}}%</p>
                    </div>
                  </div>
                </div>
              </div>

              <div class="model-item" v-if="sectorData.length>0">
                <p class="info-title">错题统计</p>
                <div class="write-txt" v-for="(item,index) in sectorData" :key="index">
                  <p class="add-title">板块{{(index+1)}}: {{item.title}} <span>扣{{item.deduct}}分</span></p>
                  <div v-for="(ele,num) in item.material" :key="num">
                    <div class="" v-for="(i,k) in ele.topic" :key="k">
                      <div class="topic-data">
                        <p class="write-title"><span>*</span>第{{k+1}}题:{{i.topic_title}}</p>
                        <div class="exam-txt">
                          <p v-for="(n,m) in i.exam_sites" :key="m">考点：{{n}}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="step-cont paper-cont" v-if="addType=='edit' || addType=='look'">
            <div class="model-item">
              <p class="info-title">基本信息</p>
              <p class="paper-title">试卷：{{exam_title}}</p>
              <div class="write-txt">
                <div class="paper-item" v-for="(item,index) in errorList" :key="index">
                  <p>错题题号:{{item.que_num}}</p>
                  <p>错题扣分:{{item.deduct}}分</p>
                </div>
              </div>
            </div>
            <div class="model-item clear" v-if="addObj.exam_sites.length>0">
              <p class="info-title">各个考点扣分情况</p>
              <div class="table-cont">
                <div class="table-title">
                  <p v-for="(item,index) in tableTitle" :key="index">{{item.title}}</p>
                </div>
                <div class="table-list">
                  <div class="table-item" v-for="(item,index) in addObj.exam_sites" :key="index">
                    <p>{{item.exam_site}}</p>
                    <p>{{item.topic_score}}</p>
                    <p>{{item.deduct}}</p>
                    <p>{{item.deduct_rate}}%</p>
                  </div>
                </div>
              </div>
            </div>

            <div class="model-item" v-if="sectorData.length>0">
              <p class="info-title">错题统计</p>
              <div class="write-txt" v-for="(item,index) in sectorData" :key="index">
                <p class="add-title">板块{{(index+1)}}: {{item.title}} <span>扣{{item.deduct}}分</span></p>
                <div v-for="(ele,num) in item.material" :key="num">
                  <div class="" v-for="(i,k) in ele.topic" :key="k">
                    <div class="topic-data">
                      <p class="write-title"><span>*</span>第{{k+1}}题:{{i.topic_title}}</p>
                      <div class="exam-txt">
                        <p v-for="(n,m) in i.exam_sites" :key="m">考点：{{n}}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="step-cont wrong-cont" :class="addType!='add'?'noPointer':''" v-if="next_id==2">
          <div class="model-item">
            <div class="write-txt" v-for="(item,index) in addObj.ea" :key="index">
              <div class="topic-data">
                <p class="add-title">错题{{(index+1)}}</p>
                <div class="write-title"><span>*</span>1{{item.topic_title}}</div>
              </div>
              <div class="wrong-cause">
                <div class="wrong-btn">
                  <div class="clear">
                    <p class="wrong-title">AI错因分析</p>
                    <button class="btn btn-wrong" @click="getAnalysis(item)">{{item.analysis?'重新分析':'开始分析'}}</button>
                  </div>
                  <div class="wrong-txt">
                    {{item.analysis?item.analysis:'暂无'}}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="step-cont score-cont" :class="addType=='look'?'noPointer':''" v-if="next_id==3">
          <div class="model-item">
            <div class="write-txt">
              <p class="write-title"><span>*</span>选择考试类型：</p>
              <div class="write-text">
                <el-select placeholder="请选择" v-model="addObj.exam_type">
                  <el-option
                    v-for="item in examTypeList"
                    :key="item.id"
                    :label="item.title"
                    :value="item.id">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="write-txt write-ai">
              <p class="write-title">考试总目标：</p>
              <div class="write-text">
                <input type="text" v-model="addObj.exam_target">
              </div>
            </div>
            <div class="write-txt">
              <p class="write-title"><span>*</span>总目标提分期限：</p>
              <div class="write-text">
                <el-date-picker
                  v-model="addObj.target_deadline"
                  type="date"
                  value-format="yyyy-MM-dd"
                  :picker-options="pickerOptions"
                  placeholder="选择日期">
                </el-date-picker>
                <!-- <p class="write-msg">仅能设置明天及以后的时间</p> -->
              </div>
            </div>
          </div>


          <div class="model-item" style="margin-top: 70px;">
            <div class="tager-list" v-for="(item,index) in addObj.models" :key="index">
              <div class="write-txt">
                <p class="write-title"><span>*</span>选择板块：</p>
                <div class="write-text">
                  <el-select placeholder="请选择" v-model="item.title" @change="examChange(item)">
                    <el-option
                      v-for="item in examDataList"
                      :key="item.id"
                      :label="item.title"
                      :value="item.title">
                    </el-option>
                  </el-select>
                </div>
              </div>
              <div class="write-txt write-score">
                <p class="write-title">目标分值：</p>
                <div class="write-text">
                  提高<input type="text" v-model="item.model_target">分
                  <button v-if="index>0" class="btn btn-topic-remove" @click="examRemove(index)">删除</button>
                </div>
              </div>
            </div>
            <button class="btn btn-score" @click="examAdd">+添加板块</button>
          </div>
        </div>

        <div class="step-cont plan-cont" :class="addType=='look'?'noPointer':''" v-if="next_id==4">
          <div class="model-item">
            <p class="info-title">总提分目标: <span>+{{totalNum}}分</span></p>
            <div class="modelsList">
              <p class="info-title">各板块提分目标: </p>
              <div style="display: block;padding-left: 100px;text-align: left;">
                <div v-for="(item,index) in addObj.models" :key="index">{{item.title}}：+{{item.model_target}}</div>
              </div>
            </div>
            <div class="write-txt" v-for="(item,index) in addObj.models" :key="index">
              <div class="topic-data">
                <p class="add-title">板块{{(index+1)}}: {{item.title}}<span>目标:{{item.model_target}}分</span></p>
              </div>
              <div class="wrong-cause">
                <div class="wrong-btn">
                  <div class="clear">
                    <p class="wrong-title">提分计划</p>
                  </div>
                  <div class="wrong-txt">
                    <textarea v-model="item.model_plan"></textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="write-btnBox" v-if="next_id==4">
          <button class="btn btn-save" @click="saveSub">确定</button>
          <button class="btn btn-close" @click="closeSub">取消</button>
        </div>
        <div class="write-btnBox" v-else>
          <button class="btn btn-save" @click="lastPage" v-if="next_id>1">上一页</button>
          <button class="btn btn-close" @click="nextPage" v-if="next_id<4">下一页</button>
        </div>
      </div>
      <div class="organiza-txt" v-else>
        <div class="organiza-title clear">
          <div class="organiza-left" @click="addSub">
            <img src="~@/assets/images/icon-add.png" alt="">
            <p>添加诊断</p>
          </div>
          <div class="searchBox clear">
            <div class="search-item">
              <p>学员姓名:</p>
              <input type="text" placeholder="请输入要搜索的学员姓名" v-model="obj.name">
            </div>
            <div class="search-item">
              <p>手机号:</p>
              <input type="text" placeholder="请输入要搜索的手机号" v-model="obj.mobile">
            </div>
            <div class="search-btnBox">
              <button class="btn btn-search" @click="searchSub">搜索</button>
              <button class="btn btn-reset" @click="resetSub">重置</button>
            </div>
          </div>
        </div>
        <div class="organiza-list">
          <div class="list-title">诊断列表</div>
          <div class="titleList">
            <p v-for="item in titleList" v-bind:key="item.id">{{item.title}}</p>
          </div>
          <div class="dataList">
            <div class="listItem" v-for="(item,index) in dataList" v-bind:key="(index+1)">
              <p :title="item.key">{{item.key}}</p>
              <p :title="item.name">{{item.name}}</p>
              <p :title="item.sex==1?'男':'女'">{{item.sex==1?'男':'女'}}</p>
              <p :title="item.province + '/' + item.city">{{item.province}} / {{item.city}}</p>
              <p :title="item.school">{{item.school}}</p>
              <p :title="item.exam_title">{{item.exam_title}}</p>
              <p :title="item.grade">{{item.grade}}</p>
              <p :title="item.mobile">{{item.mobile}}</p>
              <p :title="item.exam_time">{{item.exam_time}}</p>
              <p :title="item.add_time">{{item.add_time}}</p>
              <p>
                <button title="编辑" class="btn btn-revise" @click="buildShow(item)">编辑</button>
                <button title="删除" class="btn btn-remove" @click="removeShow(item)">删除</button>
                <button title="删除" class="btn btn-remove" @click="buildShow(item,'look')">查看诊断</button>
              </p>
            </div>
          </div>
          
          <div class="block pageBox clear">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="obj.page"
              :page-size="1"
              layout="prev, pager, next, jumper"
              :total="totalPage">
            </el-pagination> 
          </div>
        </div>
      </div>

      
    </div>

    <!-- 学生选择列表 -->
    <div class="organiza-txt studentList" v-if="listType">
      <div class="contv">
        <div class="organiza-list">
          <div class="list-title">选择学员</div>
          <div class="searchBox clear">
            <div class="search-item">
              <p>学生：</p>
              <input type="text" placeholder="请输入要搜索的学生" v-model="listObj.name">
            </div>
            <div class="search-item">
              <p>手机号：</p>
              <input type="text" placeholder="请输入要搜索的手机号" v-model="listObj.mobile"  @input="numCheck(listObj.mobile,11,'mobile')">
            </div>
            <div class="search-btnBox">
              <button class="btn btn-search" @click="studentSearch">搜索</button>
              <button class="btn btn-reset" @click="studentReset">重置</button>
            </div>
          </div>
          <div class="titleList">
            <p v-for="item in studentTitle" v-bind:key="item.id">{{item.title}}</p>
          </div>
          <div class="dataList">
            <div class="listItem" v-for="(item,index) in studentList" v-bind:key="(index+1)" @click="studentChoose(item)">
              <!-- <p :title="item.key">
                <el-checkbox v-model="item.checked" @change="$forceUpdate()"></el-checkbox>
              </p> -->
              <p :title="item.key" class="radio" :class="item.checked?'select':''">
                <span></span>
              </p>
              <p :title="item.name">{{item.name}}</p>
              <p :title="item.sex==1?'男':'女'">{{item.sex==1?'男':'女'}}</p>
              <p :title="item.province + '/' + item.city">{{item.province}} / {{item.city}}</p>
              <p :title="item.school">{{item.school}}</p>
              <p :title="item.grade">{{item.grade}}</p>
              <p :title="item.mobile">{{item.mobile}}</p>
              <p :title="item.create_time">{{item.create_time}}</p>
              <p :title="item.deadline">{{item.deadline}}</p>
            </div>
          </div>
          
          <div class="block pageBox clear">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleStudentChange"
              :current-page.sync="listObj.page"
              :page-size="1"
              layout="prev, pager, next, jumper"
              :total="listTotalPage">
            </el-pagination> 
          </div>
        </div>
        <div class="write-btnBox" style="margin-top: 20px;">
          <button class="btn btn-save" @click="studentSub">确定</button>
          <button class="btn btn-close" @click="studentHide">取消</button>
        </div>
      </div>
    </div>

    <div class="msgBox" v-if="removeType">
      <div class="contv">
        <p class="title">是否确定删除？</p>
        <div class="btnBox">
          <button class="btn btn-close" @click="ModelHide('remove')">取消</button>
          <button class="btn btn-sub" @click="removeSub">确定</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getExamSitList ,addErrorAnalysis ,saveExamSit ,getExamSitDetail ,delExamSit ,getExamSelectList,getStudentList,importExamAnswer,addAiAnalysis,getExamModelList} from "@/assets/js/api";
import navBox from './../components/comment/nav.vue';
import myHeader from './../components/comment/myHeader.vue';
import axios from "axios"
export default {
  name: "index",
  data() {
    return {
      navId:'9',
      childrenID:'9-1',
      titleList:[
        {id:1,title:'序号'},
        {id:2,title:'姓名'},
        {id:3,title:'性别'},
        {id:4,title:'地区'},
        {id:5,title:'学校'},
        {id:6,title:'试卷名称'},
        {id:7,title:'年级'},
        {id:8,title:'手机号'},
        {id:9,title:'试卷考试时间'},
        {id:10,title:'诊断时间'},
        {id:11,title:'操作'},
      ],
      dataList:[],
      addType:'',
      removeType:false,
      token:'',
      obj:{
        page:1,
        rows:10
      },
      addObj:{
        user_topic:[],
        exam_sites:[],
        fs:{
          sector:[]
        },
        models:[
          {id:'',que_num:'',title:'',model_target:'',model_plan:''}
        ]
      },
      totalPage:0,
      removeID:'',
      url:'',
      loading:false,
      loadTxt:'',
      steptTitle:[
        {id:1,title:'弱点扫描'},
        {id:2,title:'错因分析'},
        {id:3,title:'制定目标'},
        {id:4,title:'训练计划'},
      ],
      imgType:false,
      loadTxt:'',
      loading:false,
      uploadObj: {
        token: "",
        key: "",
      },
      tableTitle:[
        {id:1,title:'考点'},
        {id:2,title:'考点满分'},
        {id:3,title:'扣分'},
        {id:4,title:'扣分率'},
      ],
      next_id:1,
      examList:[],
      examDataList:[],
      listType:false,
      studentList:[],
      listTotalPage:0,
      listObj:{
        page:1,
        rows:10,
      },
      dialogVisible:false,
      studentTitle:[
        {id:1,title:'选择'},
        {id:2,title:'姓名'},
        {id:3,title:'性别'},
        {id:5,title:'地区'},
        {id:6,title:'学校'},
        {id:7,title:'年级'},
        {id:8,title:'手机号'},
        {id:9,title:'注册时间'},
        {id:10,title:'有效截止时间'},
      ],
      pickerOptions: {
        disabledDate(time) {
          console.log(time)
          // 获取当前时间的毫秒数
          const now = Date.now();
          // 获取传入日期的毫秒数
          const date = time.getTime();
          // 如果传入日期的毫秒数小于当前时间的毫秒数，则返回true，表示禁用该日期
          return date < now;
        }
      },
      imgObj:{
        eid:'',
        imgs:[],
      },
      maximum:0,
      errorObj:{
        eid:'',
        error_topic:[
          {que_num:'',deduct:0}
        ],
        user_topic:[],
      },
      examTypeList:[
        {id:1,title:'月考'},
        {id:2,title:'期中考'},
        {id:3,title:'期末考'},
        {id:4,title:'1模考'},
        {id:5,title:'2模考'},
        {id:6,title:'3模考'},
        {id:7,title:'中考'},
      ],
      totalNum:0,
      sectorData:[],
      errorList:[],
      exam_title:'',
      buildID:''
    };
  },
  components: {
    navBox,
    myHeader
  },
  mounted(){
    var userData = JSON.parse(localStorage.getItem('userData'));
    this.token = userData.adminToken;
    this.url = this.$refs.navBox.url;
    this.getList();
    this.getToken();
    this.getPaperList();
  },
  methods: {
    studentSearch(){
      this.listObj.page = 1;
      this.studentList = [];
      this.chooseStudent();
    },

    studentReset(){
      this.listObj={
        page:1,
        rows:10,
      };
      this.listTotalPage = 0;
      this.studentList = [];
      this.chooseStudent();
    },
    dateSub(type){
      // if(this.addObj.end_date <  this.addObj.begin_date && this.addObj.end_date){
      //   this.$message('结束日期禁止小于开始日期');
      //   this.addObj.end_date='';
      //   this.addObj.begin_date='';
      // }
    },
    getToken(){
      var that = this;
      var url = this.$refs.navBox.url;
      axios({
        url: url+'/api/upload/getUploadToken',
        method:'post', 
      }).then((arr) => {
        if(arr.data.code == 200){
          that.uploadObj.token = arr.data.data.token
        } else {
          that.$message(arr.data.msg);
        }
      })
      .catch((error) => {
        console.log(error);
      });
    },

    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.getList();
    },
    handleStudentChange(val) {
      console.log(`当前页: ${val}`);
      this.chooseStudent();
    },
    

    async getList(){
      var that = this;
      try {
        const response = await getExamSitList(this.obj,this.token);
        if(response.code == 200){
          that.dataList = response.data.list;
          that.totalPage = response.data.total_page;        
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    async addSub(){
      var that = this;
      this.addType = 'add';
      this.next_id = 1;
      
    },

    async getPaperList(){
      var that = this;
      try {
        const response = await getExamSelectList(this.token);
        if(response.code == 200){
          that.examList = response.data;
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    async buildShow(e,type){
      var that = this;
      this.buildID = e.id;
      try {
        const response = await getExamSitDetail({id:e.id},this.token);
        if(response.code == 200){
          if(type == 'look'){
            that.addType = 'look';
          } else {
            that.addType = 'edit';
          }
          that.examList.forEach(function(item,index){
            if(item.title == response.data.report.exam.exam_title){
              that.addObj.eid = item.id;
            }
          });
          that.exam_title = response.data.report.exam.exam_title;
          that.addObj.exam_time = response.data.report.exam.exam_time;
          that.addObj.score = response.data.report.exam.score;
          that.errorObj.error_topic = response.data.report.fs.error;
          that.addObj.exam_sites = response.data.report.fs.exam_sites;
          that.sectorData = response.data.report.fs.sector;
          that.addObj.ea = response.data.report.ea;
          that.addObj.exam_type = response.data.report.sg.exam_type;
          that.addObj.exam_target = response.data.report.sg.exam_target;
          that.addObj.target_deadline = response.data.report.sg.target_deadline;
          that.addObj.models = response.data.report.sg.models;
          that.totalNum = response.data.report.tp.increase_score;
          that.errorList = response.data.report.fs.error;
          that.next_id =1;
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
      
    },

    removeShow(e){
      this.removeID = e.id;
      this.removeType = true;
    },

    async removeSub(){
      var that = this;
      try {
        const response = await delExamSit({id:this.removeID},this.token);
        if(response.code == 200){
          that.$message('删除成功');
          that.getList();
          that.ModelHide('remove');       
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    ModelHide(type){
      var that = this;
      if(type == 'remove'){
        that.removeType = false;
        taht.removeID = '';
      }
    },

    async buildSave(){
      var that = this;
      console.log(this.addObj);
      var obj = {
        id:that.buildID,
        exam_type:this.addObj.exam_type,
        exam_target:this.addObj.exam_target,
        target_deadline:this.addObj.target_deadline,
        models:this.addObj.models,
      }
      try {
        const response = await saveExamSit(obj,this.token);
        if(response.code == 200){
          that.$message('成功');
          that.closeSub();
          that.getList();        
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    async saveSub(){
      var that = this;
      console.log(this.addObj);
      if(this.addType == 'edit'){
        this.buildSave();
        return false;
      }
      if(this.addObj.eid == '' || !this.addObj.eid){
        that.$message('请选择考试！');
        return false;
      }
      if(this.addObj.uid == '' || !this.addObj.uid){
        that.$message('请选择学生！');
        return false;
      }
      if(this.addObj.exam_time == '' || !this.addObj.exam_time){
        that.$message('请选择考试时间！');
        return false;
      }
      if(this.addObj.score == '' || !this.addObj.score){
        that.$message('请填写考试成绩！');
        return false;
      }
      if(this.addObj.exam_type == '' || !this.addObj.exam_type){
        that.$message('请选择考试类型！');
        return false;
      }
      if(this.addObj.exam_target == '' || !this.addObj.exam_target){
        that.$message('请填写考试总目标！');
        return false;
      }
      if(this.addObj.target_deadline == '' || !this.addObj.target_deadline){
        that.$message('请选择总目标提分期限！');
        return false;
      }
      // if(this.addObj.period == ''){
      //   that.$message('请选择学段！');
      //   return false;
      // }
      // if(this.addObj.content == ''){
      //   that.$message('请填写文章内容！');
      //   return false;
      // }
      // if(this.addObj.explain == ''){
      //   that.$message('请填写解题步骤！');
      //   return false;
      // }
      // if(this.addObj.material_label_one == '' || this.addObj.material_label_one == '生成中...'){
      //   that.$message('请选择文章一级标签！');
      //   return false;
      // }
      // try {
      //     that.addObj.topic.forEach(function(item,index){
      //       if(item.topic == ''){
      //           that.$message('题目'+(index+1)+'题干还未填写');
      //           throw new Error("EndIterative");
      //       } 
      //       if(item.answer == ''){
      //           that.$message('题目'+(index+1)+'答案还未填写');
      //           throw new Error("EndIterative");
      //       } 
      //       if(item.topic_label_one == '' || item.topic_label_one == '生成中...'){
      //           that.$message('题目'+(index+1)+'题干一级标签还未填写');
      //           throw new Error("EndIterative");
      //       } 
      //     })
      // } catch(e) {
      //     if (e.message != "EndIterative") {
      //         throw e;
      //     } else {
      //         return // 如果跳出forEach循环的同时要终止下面的代码执行  则写这个  如果要继续执行下面的代码  则不需要return
      //     }
      // };
      // this.addObj.fs.sector = this.addObj.fs;
      console.log(this.sectorData)
      this.addObj.fs.sector = this.sectorData;
      console.log(this.addObj)
      try {
        const response = await saveExamSit(that.addObj,this.token);
        if(response.code == 200){
          that.$message('成功');
          that.closeSub();
          that.getList();        
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    closeSub(){
      this.addType = '';
      this.addObj = {
        user_topic:[],
        exam_sites:[],
        fs:[],
        models:[
          {id:'',que_num:'',title:'',model_target:'',model_plan:''}
        ]
      };
      this.imgObj = {
        eid:'',
        imgs:[],
      }
    },

    searchSub(){
      this.obj.page = 1;
      this.dataList = [];
      this.getList();
    },

    resetSub(){
      this.obj={
        page:1,
        rows:10,
      };
      this.addObj={
        user_topic:[],
        exam_sites:[],
        fs:[],
        models:[
          {id:'',que_num:'',title:'',model_target:'',model_plan:''}
        ]
      };
      this.totalPage = 0;
      this.dataList = [];
      this.getList();
    },

    imgShow(){
      this.imgType = true;
    },

    imgHide(){
      this.imgType = false;
    },

    imgRemove(i){
      this.imgObj.imgs.splice(i,1)

    },

    beforeUploadImg(file) {
      this.loading = true;
      this.uploadObj.key = file.uid + file.name; // key为上传后文件名 必填
    },

    handleSuccessImg(response, file, fileList,index,type,num) {
      var that = this;
      this.imgObj.imgs.push(response.key)
      that.loading = false;
      that.uploadObj.key = "";
    },

    handleProgressImg(event, file, fileList) {
      this.loadTxt = "已上传" + file.percentage.toFixed(0) + "%";
    },

    handleRemoveImg() {
      this.uploadUrl = "";
      this.addObj.image = "";
    },

    stepSub(e){
      var that = this;
      this.next_id = e.id;
      if(this.next_id == 3){
        if(this.addObj.eid =='' || !this.addObj.eid){
          that.$message('请选择试卷！');
          return false;
        }
        this.getExamList();
      }
      if(this.next_id == 4){
        that.totalNum = 0;
        this.addObj.models.forEach(function(item,index){
          that.totalNum = parseInt(that.totalNum) + parseInt(item.model_target);
        })
      }
    },

    async getExamList(){
      var that = this;      
      try {
        const response = await getExamModelList({eid:this.addObj.eid},this.token);
        if(response.code == 200){
          that.examDataList = response.data;
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    async chooseStudent(){
      var that = this;      
      try {
        const response = await getStudentList(this.listObj,this.token);
        if(response.code == 200){
          that.listType = true;
          response.data.list.forEach(function(item,index){
            console.log(that.addObj.uid,item.id,that.addObj.uid==item.id)
            if(that.addObj.uid == item.id){
              item.checked = true;
            } else {
              item.checked = false;
            }
          })
          that.studentList = response.data.list;
          that.listTotalPage = response.data.total_page;
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    studentChoose(e){
      console.log(e.checked)
      this.studentList.forEach(function(item,index){
        if(e.id == item.id){
          item.checked = !item.checked;
        } else {
          item.checked = false;
        }
      });
      this.$forceUpdate();
    },

    studentSub(){
      var that = this;
      this.listType = false;
      this.studentList.forEach(function(item,index){
        if(item.checked){
          that.addObj.uid = item.id
        }
      });
      console.log(this.addObj.uid)
    },

    studentHide(){
      this.listType = false;
      this.studentList = [];
      // this.addObj.uid = '';
    },

    async answerSub(){
      var that = this;
      this.imgObj.eid = this.addObj.eid;
      if(!this.imgObj.eid){
        that.$message('请选择试卷');
        return false;
      }
      if(this.imgObj.imgs.length == 0){
        that.$message('请上传答题照片！');
        return false;
      }
      that.loading = true;
      this.loadTxt = '请稍后...';
      try {
        const response = await importExamAnswer(this.imgObj,this.token);
        if(response.code == 200){
          response.data.user_topic.forEach(function(item,index){
            item.topic.forEach(function(ele,num){
              if(!ele.my_answer){
                ele.my_answer = '无'
              }
            })
          })
          that.addObj.user_topic = response.data.user_topic;
          var length1 = response.data.user_topic.length;
          var length2 = response.data.user_topic[length1-1].topic.length;
          that.maximum = response.data.user_topic[length1-1].topic[length2-1].que_num;
          that.loading = false;
          that.loadTxt = '';
        } else {
          that.$message(response.msg);
          that.loading = false;
          that.loadTxt = '';
        }
      } catch (error) {
        that.$message(error);
        that.loading = false;
        that.loadTxt = '';
      }
    },

    addError(){
      this.errorObj.error_topic.push({que_num:'',deduct:0})
    },

    errorRemove(i){
      this.errorObj.error_topic.splice(i,1)
    },

    async ErrorAnalysis(){
      var that = this;
      that.loading = true;
      this.loadTxt = '请稍后...';
      this.errorObj.user_topic = this.addObj.user_topic;
      this.errorObj.eid = this.addObj.eid;
      that.addObj.exam_sites = [];
      that.sectorData = [];
      that.addObj.ea = [];
      if(this.errorObj.error_topic.length==1){
        if(this.errorObj.error_topic[0].que_num == '' && this.errorObj.error_topic[0].deduct == 0){
         this.errorObj.error_topic = []
        }
      }
      try {
        const response = await addErrorAnalysis(this.errorObj,this.token);
        if(response.code == 200){
          that.addObj.exam_sites = response.data.exam_sites;
          that.sectorData = response.data.fs.sector;
          that.addObj.ea = response.data.ea;
          that.loading = false;
          that.loadTxt = '';
        } else {
          that.$message(response.msg);
          that.loading = false;
          that.loadTxt = '';
        }
      } catch (error) {
        that.$message(error);
        that.loading = false;
        that.loadTxt = '';
      }
    },

    async getAnalysis(e){
      var that = this;
      var obj = {
        content:e.content,
        topic:e.topic_title,
        answer:e.answer,
        my_answer:e.my_answer
      };
      this.loadTxt = '请稍后';
      this.loading = true;
      try {
        const response = await addAiAnalysis(obj,this.token);
        if(response.code == 200){
          e.analysis = response.data.answer;
          that.loadTxt = '';
          that.loading = false;
          that.$forceUpdate();
        } else {
          that.$message(response.msg);
          that.loadTxt = '';
          that.loading = false;
        }
      } catch (error) {
        that.$message(error);
        that.loadTxt = '';
        that.loading = false;
      }
    },

    examChange(e){
      var that = this;
      this.examDataList.forEach(function(item,index){
        if(item.title == e.title){
          e.id = item.id;
          e.que_num = item.que_num
        }
      })
      console.log(e,'eee')
    },

    examAdd(){
      this.addObj.models.push({id:'',que_num:'',title:'',model_target:'',model_plan:''})
    },

    examRemove(i){
      this.addObj.models.splice(i,1)
    },

    lastPage(){
      this.next_id = parseInt(this.next_id - 1);
      if(this.next_id == 3){
        if(this.addObj.eid =='' || !this.addObj.eid){
          that.$message('请选择试卷！');
          return false;
        }
        this.getExamList();
      }
      if(this.next_id == 4){
        if(this.addObj.models.length > 0){
          that.totalNum = 0;
          that.addObj.models.forEach(function(item,index){
            that.totalNum = parseInt(that.totalNum) + parseInt(item.model_target);
          })
        }
       
      }
    },

    nextPage(){
      var that = this;
      this.next_id = parseInt(this.next_id + 1);
      if(this.next_id == 3){
        if(this.addObj.eid =='' || !this.addObj.eid){
          that.$message('请选择试卷！');
          return false;
        }
        this.getExamList();
      }
      if(this.next_id == 4){
        if(this.addObj.models.length > 0){
          that.totalNum = 0;
          that.addObj.models.forEach(function(item,index){
            that.totalNum = parseInt(that.totalNum) + parseInt(item.model_target);
          })
        }
       
      }
    },

    paperChange(){
      this.addObj.models = [
          {id:'',que_num:'',title:'',model_target:'',model_plan:''}
      ];
    }
  },

  

  
};
</script>
<style scoped>
  .dataList .listItem p, 
  .organiza-list p{
    width: calc( 100% / 11 );
    white-space: nowrap; /* 禁止文本换行 */
    overflow: hidden; /* 隐藏超出范围的内容 */
    text-overflow: ellipsis; /* 使用省略号 */
    padding: 21px 5px;
  }

  .add-title,
  .list-title{
    color: #333333;
    font-size: 22px;
    display: block;
    margin-bottom: 20px;
    position: relative;
    padding-left: 20px;
    line-height: 40px;
  }

  .add-title::before,
  .list-title::before{
    content: '';
    width: 5px;
    height: 22px;
    background-color: #6098F2;
    position: absolute;
    top: 50%;
    transform: translate(0,-50%);
    left: 5px;
  }

  .MobelBox{
    padding: 40px;
    box-sizing: border-box;
    width: 100%;
  }

  .MobelBox .write-txt{
    display: block;
    width: 100%;
    margin-bottom: 20px;
  }

  .MobelBox .write-text{
    display: inline-block;
    vertical-align: top;
    width: 80%;
    margin-left: 20px;
  }

  .MobelBox .write-text span{
    font-size: 14px;
    color: #E2231A;
    margin-top: 10px;
    display: block;
  }

  .MobelBox input,
  .MobelBox textarea{
    width: 80%;
    height: 334px;
    background-color: #FFFFFF;
    border-radius: 6px;
    display: block;
    padding: 20px;
    box-sizing: border-box;
    border: solid 1px #333333;
    font-size: 16px;
  }

  .MobelBox input{
    height: 50px;
    line-height: 50px;
    width: 500px;
  }

  .MobelBox>>> .el-input{
    font-size: 16px;
  }

  .msgBox .contv{
    padding: 40px 73px;
    border-radius: 32px;
  }

.msgBox .title {
  text-align: center;
  margin-bottom: 50px;
}

.btn-import{
  display: inline-block;
  vertical-align: top;
}

.btn-topic-remove,
.btn-ai{
  background-color: #6098F2;
  border-radius: 6px;
  color: #fff;
  font-size: 16px;
  color: #fff;
  box-sizing: border-box;
  padding: 0px 20px;
  height: 39px;
  line-height: 39px;
  display: inline-block;
  margin-left: 20px;
}

.btn-topic-remove{
  background-color: #F26060;
}

.ai-msg{
  height: 50px;
  line-height: 50px;
  color: #777777;
  font-size: 14px;
  display: inline-block;
  margin-left: 18px;
}

.MobelBox .write-ai .write-text{
  width: auto;
}


.topicList{
  display: block;
}

.topic-title{
  font-size: 20px;
  color: #333333;
  display: inline-block;
  vertical-align: top;
  height: 36px;
  line-height: 36px;
  margin-bottom: 20px;
}

.topic-title .btn-add,
.topic-title .btn-remove{
  font-size: 18px;
  color: #fff;
  display: inline-block;
  vertical-align: top;
  height: 36px;
  line-height: 36px;
  background-color: #6098F2;
  background-image: none;
  width: 110px;
  border-radius: 6px;
}

.topic-title .btn-remove{
  margin-left: 40px;
  background-color: transparent;
  color: #6098F2;
  border: solid 1px #6098F2;
}

.topic-title .btn-add{
  background-color: #F5F5F5;
  color: #999999;
  margin-left: 20px;
}

.organiza-txt>>>.el-upload{
  width: 100%;
  display: block;
}

.organiza-txt>>>.el-button--small span{
  width: 100%;
  text-align: center;
  display: block;
}

.organiza-txt>>>.el-button--primary{
  background-color: transparent;
  border: none;
  font-size: 15px;
}

.btn-topic-add{
  font-size: 18px;
  color: #6098F2;
  margin: 30px 0 20px;
  display: block;  
  border: solid 1px #6098F2;
  border-radius: 6px;
  padding: 3px 30px;
  box-sizing: border-box;
}

.btn-error{
  color: #FFFFFF;
  font-size: 16px;
  background-color: #6098F2;  
  border-radius: 6px;
  box-sizing: border-box;
  padding: 9px 24px;
  display: block;
  margin: 30px 0 0 0;
}

.model-cont{
  background-color: #fff;
  display: block;
  box-sizing: border-box;
  padding: 30px;
  border-radius: 6px;
  margin-bottom: 10px;
}

.MobelBox .model-cont .btn-hide{
  margin: 0 0 10px;
}

.model-cont .ai-msg{
  font-size: 12px;
  color: #999999;
}

.model-cont .msg-txt{
  background-color: #FFF0F0;
  border-radius: 6px;
  font-size: 12px;
  color: #333333;
  display: inline-block;
  vertical-align: top;
  padding: 11px 20px;
  box-sizing: border-box;
  margin-left: 10px;
}

.model-cont .icon-msg{
  background-image: url(~@/assets/images/icon-msg.png);
  width: 16px;
  height: 16px;
  background-size: 16px 16px;
  display: inline-block;
  vertical-align: middle;
}

.model-cont .add-title{
  font-size: 18px;
  font-weight: bold;
}

.model-cont .add-title span{
  font-size: 14px;
  color: #FFFFFF;
  background-color: #F26060;
  border-radius: 6px;
  box-sizing: border-box;
  padding: 3px 10px;
  margin-left: 22px;
}

.model-cont .topic-data1,
.model-cont .topic-data2{
  margin-bottom: 20px;
}

.model-cont .topic-data1 textarea{
  border: none;
  height: auto;
}

.model-cont .topic-data2 textarea{

}

.step-cont{
  display: block;
}

.step-list{
  font-size: 0;
  display: block;
  text-align: center;
}

.step-list .step-item{
  display: inline-block;
  vertical-align: top;
  text-align: center;
  position: relative;
  margin-right: 150px;
}

.step-list .step-item.select p{
  border-color: #6098F2;
  background-color: #6098F2;
  color: #fff;
}

.step-list .step-item p{
  width: 60px;
  height: 60px;
  line-height: 60px;
  border-radius: 100%;
  border: solid 2px #777777;
  font-size: 28px;
  color: #777777;
  display: block;
  margin: 0 auto .05rem;
}

.step-list .step-item.select span{
  color: #6098F2;
}

.step-list .step-item span{
  color: #777777;
  font-size: 18px;
  display: block;
  margin-top: 6px;
}

.step-list .step-item .line{
  width: 150px;
  height: 2px;
  background-color: #777777;
  position: absolute;
  top: 29px;
  right: -150px;
}

.info-title{
  font-size: 20px;
  color: #333333;
  display: block;
  margin: 20px 0;
  font-weight: bold;
}

.table-cont{
  display: block;
  width: 80%;
  float: right;
  text-align: center;
}

.table-list .table-item,
.table-cont .table-title{
  font-size: 0;
}

.table-list .table-item p,
.table-cont .table-title p{
  width: 25%;
  font-size: 18px;
  color: #333333;
  font-weight: bold;
  padding: 20px 10px;
  box-sizing: border-box;
  background-color: #F0F4FB;
  display: inline-block;
  vertical-align: top;
}

.table-list .table-item p{
  background-color: #fff;
}

.wrong-cont .write-title,
.wrong-cont .add-title{
  display: inline-block;
  vertical-align: top;
}

.wrong-cont .write-title{
  line-height: 40px;
  margin-left: 24px;
}

.wrong-cause{
  font-size: 0;
}

.wrong-title{
  font-size: 18px;
  color: #333333;
  float: left;
  line-height: 40px;
}

.wrong-cause .btn-wrong{
  line-height: 40px;
  color: #6098F2;
  border-radius: 6px;
  border: solid 1px #6098F2;
  float: right;
  font-size: 16px;
  box-sizing: border-box;
  padding: 0 25px;
}

.wrong-cause .wrong-txt{
  border-radius: 6px;
  font-size: 14px;
  color: #333333;
  box-sizing: border-box;
  padding: 20px;
  margin-top: 10px;
}

.wrong-cause .wrong-txt textarea{
  background-color: #EDEDED;
  border: none;
}

.tager-list .write-score{
  margin-left: 50px;
}

.tager-list .write-score .write-text{
  font-size: 18px;
  color: #333333;
}

.tager-list .write-score .write-text input{
  display: inline-block;
  margin: 0 10px;
}

.score-cont .btn-score{
  font-size: 18px;
  color: #6098F2;
  box-sizing: border-box;
  padding: 6px 24px;
  border-radius: 6px;
  border: solid 1px #6098F2;
  display: block;
  margin-top: 30px;
}

.plan-cont .info-title span{
  font-size: 24px;
  color: #54EF07;
  margin-left: 25px;
}

.plan-cont .add-title span{
  font-size: 18px;
  color: #54EF07;
  margin-left: 35px;
}

.studentList{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .6);
}

.studentList .contv{
  background-color: #fff;
  border-radius: 6px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  box-sizing: border-box;
  padding: 30px 40px;
  width: 80%;
  height: 80%;
}

.studentList .search-item p{
  padding: 0;
  width: 100px;
}

.studentList .dataList .listItem p.radio span{
  width: 20px;
  height: 20px;
  background-color: #D9D9D9;
  border-radius: 4px;
  display: block;
}

.studentList .dataList .listItem p.select span{
  background-color: #6098F2;
}

.studentList .dataList .listItem p.select span::before{
  content: '✔';
  width: 20px;
  height: 20px;
  display: block;
  color: #ffff;
  margin: 0 5px;
}

.studentList .titleList p,
.studentList .dataList .listItem p{
  width: calc( 100% / 9 );
}

.studentList .write-btnBox{
  margin-top: 20px;
}

.studentList .organiza-list{
  height: 90%;
}

.img .hover{
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(0,0,0,.6);
}

.img .hover i{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  font-size: 20px;
  color: #fff;
  cursor: pointer;
}

.btn-img-add{
  color: #fff;
  background-color: #6098F2;
  border-radius: 6px;
  font-size: 16px;
  display: inline-block;
  vertical-align: bottom;
  box-sizing: border-box;
  padding: 10px 40px;
  margin-left: 30px;
}

.exam-txt{
  font-size: 0;
  margin-top: 10px;
}

.exam-txt p{
  display: block;
  font-size: 14px;
  color: #6098F2;
  padding-bottom: 10px;
}

.modelsList{
  font-size: 0;
  text-align: center;
  margin: 20px 0 70px;
  display: block;
}

.modelsList p{
  text-align: left;
}

.modelsList div{
  font-size: 18px;
  color: #333333;
  margin: 0 30px 20px 0;
  display: inline-block;
  vertical-align: top;
}

.paper-title{
  font-size: 20px;
  color: #333333;
  margin: 10px 0 20px 80px;
  display: block;
}

.paper-cont .write-txt{
  font-size: 0;
  width: calc( 100% - 80px );
  margin-left: 80px;
}

.paper-cont .write-txt .paper-item{
  display: inline-block;
  vertical-align: top;
  width: calc( 100% / 5 - 30px );
  background-color: #F8F9FC;
  border-radius: 6px;
  margin:0 30px 20px 0;
  box-sizing: border-box;
  padding: 10px 16px;
}

.paper-cont .write-txt .paper-item p{
  display: block;
  font-size: 18px;
  color: #333333;
}

.paper-cont .write-txt .paper-item p:first-child{
  margin-bottom: 14px;
}

.paper-cont .add-title span{
  background-color: #F26060;
  color: #fff;
  padding: 3px 10px;
  box-sizing: border-box;
  margin-left: 20px;
  border-radius: 6px;
}
</style>



// WEBPACK FOOTER //
// src/study/index.vue